export class TimezoneInfo {
  zoneName?: string;
  offset?: number;
  offsetName?: string;

  public static getUTCOffsetString(offset: number): string {
    const sign = offset >= 0 ? '+' : '-';
    const hours = Math.floor(Math.abs(offset) / 60);
    const minuts = Math.abs(offset) % 60;
    return `${sign}${String(hours * 100 + minuts).padStart(4, '0')}`;
  }
}
